var _circle, _path, _circle2, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnectionGuaranteed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 3,
    fill: "#E02F84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10c-2.5 0-4.5 2-4.5 4.5V17c0 .5.4 1 1 1h7c.6 0 1-.5 1-1v-2.5c0-2.5-2-4.5-4.5-4.5z",
    fill: "#E02F84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 6,
    r: 3,
    fill: "#E02F84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10c-2.5 0-4.5 2-4.5 4.5V17c0 .5.4 1 1 1h7c.6 0 1-.5 1-1v-2.5c0-2.5-2-4.5-4.5-4.5z",
    fill: "#E02F84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8l.5 2 2 .5-2 .5-.5 2-.5-2-2-.5 2-.5.5-2z",
    fill: "#E02F84"
  })));
}

export default SvgConnectionGuaranteed;